import React from 'react';
import { Link } from 'react-router-dom';
import { yachts } from '../data/mock';

const FleetSection = () => {
  return (
    <section className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Our Signature Fleet
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Handpicked vessels offering the ultimate in luxury and performance
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {yachts.map((yacht) => (
            <div
              key={yacht.id}
              className="group bg-gray-900 rounded-2xl overflow-hidden border border-gray-800 hover:border-orange-500/50 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={yacht.image}
                  alt={yacht.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1.5 bg-gray-900/80 backdrop-blur-sm text-white text-sm font-medium rounded-lg">
                    {yacht.type}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-serif font-bold text-white mb-2">{yacht.name}</h3>
                <div className="flex items-center gap-2 text-white/60 text-sm mb-4">
                  <span>{yacht.length}</span>
                  <span className="text-orange-500">•</span>
                  <span>{yacht.guests} Guests</span>
                  <span className="text-orange-500">•</span>
                  <span>{yacht.crew} Crew</span>
                </div>
                <p className="text-white/70 text-sm leading-relaxed mb-6 line-clamp-3">
                  {yacht.description}
                </p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-white/50 text-sm">From</span>
                    <p className="text-2xl font-bold text-orange-500">
                      ${yacht.price.toLocaleString()}<span className="text-sm font-normal text-white/50">/day</span>
                    </p>
                  </div>
                  <Link
                    to={`/yachts/${yacht.id}`}
                    className="px-5 py-2.5 border border-orange-500 text-orange-500 text-sm font-medium rounded-lg hover:bg-orange-500 hover:text-white transition-all duration-300"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/yachts"
            className="inline-block px-8 py-4 border border-white/30 text-white font-medium rounded-lg hover:bg-white/10 transition-all duration-300"
          >
            View All Yachts
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FleetSection;
